export const formatearNumero = (valor, moneda = "$") => {
  if (isNaN(valor)) return valor;
  return `${moneda}${Number(valor).toLocaleString("es-MX")}`;
};
